import React from 'react';
import PropTypes from 'prop-types';

export const Canceled = ({ width, height, ...props }) => (
  <svg
    data-icon='canceled'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12.8 23a8.215 8.215 0 0 1-3.85-.938A8.02 8.02 0 0 1 6 19.45L1.2 12.4l.474-.475c.334-.35.746-.55 1.238-.6.491-.05.937.067 1.337.35l2.75 1.9V4c0-.283.096-.52.288-.712A.968.968 0 0 1 7.999 3c.284 0 .521.096.713.288.191.191.287.429.287.712v13.425L5.3 14.85l2.375 3.45A6.14 6.14 0 0 0 9.9 20.288a6.12 6.12 0 0 0 2.9.712c1.717 0 3.18-.604 4.388-1.813 1.208-1.208 1.812-2.67 1.812-4.387V5c0-.283.096-.52.288-.713A.968.968 0 0 1 19.999 4c.284 0 .521.096.713.287.191.192.287.43.287.713v9.8c0 2.283-.796 4.22-2.387 5.813C17.02 22.204 15.082 23 12.799 23ZM11 12V2c0-.283.095-.52.287-.712A.968.968 0 0 1 11.999 1c.284 0 .521.096.713.288.191.191.287.429.287.712v10h-2Zm4 0V3c0-.283.095-.52.287-.712A.968.968 0 0 1 15.999 2c.284 0 .521.096.713.288.191.191.287.429.287.712v9h-2Z'
    />
  </svg>
);

Canceled.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Canceled.defaultProps = {
  width: 24,
  height: 24,
};
